export enum Pages {
  Overview = 'overview',
  Contests = 'contests',
  Orders = 'orders',
  Profile = 'profile',
  Affiliation = 'affiliation',
  Achievements = 'achievements',
  Playbook = 'playbook',
  Autochartist = 'autochartist',
  AssetsSpecifications = 'assets-specifications',
  HubDownloads = 'hub-downloads',
  HubVod = 'hub-vod',
  TradingPlan = 'trading-plan',
  AffiliateKit = 'affiliate-kit',
  PerformanceCoach = 'performance-coach',
  TradeTalk = 'trade-talk',
  Charts = 'charts',
  CommunityStats = 'asset-stats',
}

export enum AffiliateKitPages {
  AffiliateKit = 'affiliate-kit',
  AffiliateKitDark = 'affiliate-kit-dark',
}

export const defaultSidebar = [
  {
    page: Pages.Overview,
    label: 'Overview',
  },
  {
    page: Pages.Orders,
    label: 'Orders',
  },
  {
    page: Pages.Affiliation,
    label: 'Affiliation',
  },
];

export interface SidebarItem {
  label: string;
  page: Pages;
  isNew?: boolean;
}

export type NavigationItem = {
  label: string;
  page: Pages;
};
